import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { AppointmentProvider } from "@/components/AppointmentModal";
import { SeoHead } from "@/components/SeoHead";
import HomePage from "@/pages/HomePage"; // eagerly load — LCP page

// Lazy-loaded routes reduce initial JS bundle significantly
const DoctorsPage = lazy(() => import("@/pages/DoctorsPage"));
const DoctorPage = lazy(() => import("@/pages/DoctorPage"));
const ServicePage = lazy(() => import("@/pages/ServicePage"));
const BlogPage = lazy(() => import("@/pages/BlogPage"));
const BlogArticlePage = lazy(() => import("@/pages/BlogArticlePage"));
const ReviewsPage = lazy(() => import("@/pages/ReviewsPage"));
const QuestionsPage = lazy(() => import("@/pages/QuestionsPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));
const TestPage = lazy(() => import("@/pages/TestPage"));
const NewsPage = lazy(() => import("@/pages/NewsPage"));
const NewsArticlePage = lazy(() => import("@/pages/NewsArticlePage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

const RouteFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center" data-testid="route-loading">
    <div className="w-8 h-8 border-4 border-[#E8590A]/25 border-t-[#E8590A] rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AppointmentProvider>
        <Layout>
          <SeoHead />
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/doctors" element={<DoctorsPage />} />
              <Route path="/doctors/:slug" element={<DoctorPage />} />
              <Route path="/diagnostyka" element={<ServicePage />} />
              <Route path="/katarakta" element={<ServicePage />} />
              <Route path="/kids" element={<ServicePage />} />
              <Route path="/presbyopia" element={<ServicePage />} />
              <Route path="/sitkivka" element={<ServicePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/questions" element={<QuestionsPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/test" element={<TestPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/news/:slug" element={<NewsArticlePage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </Layout>
      </AppointmentProvider>
    </BrowserRouter>
  );
}

export default App;
